import React from 'react';

interface TournamentItem {
  id: string;
  name: string;
  logo?: string | null;
  country?: string | null;
  created_at?: string | null;
}

interface Props {
  tournaments: TournamentItem[];
  loading?: boolean;
}

const MyTournamentsSection: React.FC<Props> = ({ tournaments, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-5">
        <h2 className="text-lg font-semibold text-gray-900 mb-3">My Tournaments</h2>
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!tournaments || tournaments.length === 0) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5">
      <h2 className="text-lg font-semibold text-gray-900 mb-3">My Tournaments</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500">
              <th className="py-2 pr-4">Logo</th>
              <th className="py-2 pr-4">Tournament</th>
              <th className="py-2 pr-4">Country</th>
              <th className="py-2 pr-4">Created</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {tournaments.map((t) => (
              <tr key={t.id}>
                <td className="py-2 pr-4">
                  {t.logo ? (
                    <img src={t.logo} alt={t.name} className="w-8 h-8 rounded object-cover" />
                  ) : (
                    <div className="w-8 h-8 rounded bg-gray-100 flex items-center justify-center">🏆</div>
                  )}
                </td>
                <td className="py-2 pr-4 text-gray-900 font-medium">{t.name}</td>
                <td className="py-2 pr-4">{t.country || '—'}</td>
                <td className="py-2 pr-4">{t.created_at ? new Date(t.created_at).toLocaleDateString() : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyTournamentsSection;


